"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotify = void 0;
var context_1 = require("./context");
function useNotify() {
    var notifications = (0, context_1.useNotifications)();
    return {
        success: function (title, duration) {
            return notifications.add({
                title: title,
                type: 'success',
                duration: duration,
            });
        },
        error: function (title, duration) {
            return notifications.add({
                title: title,
                type: 'error',
                duration: duration,
            });
        },
    };
}
exports.useNotify = useNotify;
